import { TrackByFunction } from '@angular/core';

export function trackByIdFn<T>(index: number, item: { id: T }) {
  return trackByIdExtractorFn(({ id }) => id)(index, item);
}

export function trackByIdExtractorFn<T>(idExtractor: (item) => T): TrackByFunction<T> {
  return (index, item) => idExtractor(item);
}
